export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/admin": [6,[2,3]],
		"/(app)/admin/chats": [7,[2,3]],
		"/(app)/admin/functions": [8,[2,3]],
		"/(app)/admin/functions/create": [9,[2,3]],
		"/(app)/admin/functions/edit": [10,[2,3]],
		"/(app)/admin/gallery": [11,[2,3]],
		"/(app)/admin/oauth": [12,[2,3]],
		"/(app)/admin/oauth/test": [13,[2,3]],
		"/(app)/admin/scenario-tests": [14,[2,3]],
		"/(app)/admin/settings": [15,[2,3]],
		"/(app)/admin/users": [16,[2,3]],
		"/(app)/admin/workspaces": [17,[2,3]],
		"/auth": [20],
		"/auth/oauth/authorize": [21],
		"/auth/reset-password": [22],
		"/auth/verify_email": [24],
		"/auth/verify": [23],
		"/auth/webdev-auth-failed": [25],
		"/auth/webdev-auth-success": [26],
		"/(app)/c/[id]": [18,[2]],
		"/error": [27],
		"/(app)/home": [19,[2,4]],
		"/ppt/[chatId]": [28],
		"/space/[id]": [30],
		"/s/[id]": [29]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';